import React from 'react';
import Flexbox from 'flexbox-react';
import { Card } from '@blueprintjs/core';
import ContainerIntroBox from '../../components/goal_performance/ContainerIntroBox.js';
import ReadOnlyNotice from '../../components/goal_performance/ReadOnlyNotice.js';
import AssessmentQuestionList from '../../components/goal_performance/AssessmentQuestionList.js';
import AssessmentReadOnlyList from '../../components/goal_performance/AssessmentReadOnlyList.js';
import GoalReadOnlyList from '../../components/goal_performance/GoalReadOnlyList.js';
import GoalRatingForm from '../../components/goal_performance/GoalRatingForm.js';
import EmptyStateNotice from '../../components/goal_performance/EmptyStateNotice.js';
import OutlinedButton from '../../components/buttons-20250224T111359Z-001/buttons/OutlinedButton.jsx';
import FilledButton from '../../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx';

const SelfTabContent = ({
    selfAssessmentStatus,
    assessmentQuestionList,
    assessmentSubmittedList,
    assessmentSubmittedGroups,
    goalList,
    goalSubmittedList,
    finalAssessmentRating,
    finalAssesCalcRatingLabel,
    finalRating,
    finalGoalCalcRatingLabel,
    goalSubmittedRatingLabel,
    finalSubmittedAssessmentRating,
    finalSubmittedAssessmentRatingLabel,
    selectedTimeframe,
    goalRatings,
    onRatingChange,
    onAssessmentRatingChange,
    onSubmitForm,
    SELF_ASSESSMENT_STATUS,
    answers,
    assessmentRatings,
    categoryWiseRatings,
    remarkAnswers,
    updateRemarkAnswer,
    onChange,
    onCheckboxChange,
    onFileUpload,
    combinedSelfFinalRating,
    combinedSelfFinalRatingLabel,
    combinedSubmittedFinalRating,
    combinedSubmittedFinalRatingLabel,
    assessmentQuestionGroups,
    subGoalsByGoalId,
    openSubGoals,
    toggleSubGoals,
    accountId,
    accountVisibilityConfig,
    setShowPublishConfirm,
    hideGoalSection = false,
    hideRatingSummary = false,
    hideQuestionRatings = false,
    showEmptySelfStepActions = false,
    isReadOnly = false,
}) => {
    const isGoalsEmpty =
        goalList.length == 0 && goalSubmittedList.length == 0;
    const hasAssessmentQuestions =
        (assessmentQuestionGroups &&
            assessmentQuestionGroups.length > 0) ||
        (assessmentQuestionList && assessmentQuestionList.length > 0);
    const hasAssessmentCategoryRemarks =
        Array.isArray(assessmentQuestionGroups) &&
        assessmentQuestionGroups.some(group =>
            (Array.isArray(group?.remark_questions) &&
                group.remark_questions.length > 0) ||
            (Array.isArray(group?.comment_questions) &&
                group.comment_questions.length > 0)
        );
    const hasAssessmentContent =
        hasAssessmentQuestions || hasAssessmentCategoryRemarks;
    const hasSubmittedAssessmentContent =
        (assessmentSubmittedList?.length || 0) > 0 ||
        (Array.isArray(assessmentSubmittedGroups) &&
            assessmentSubmittedGroups.some(group =>
                (Array.isArray(group?.questions) && group.questions.length > 0) ||
                (Array.isArray(group?.remark_questions) &&
                    group.remark_questions.length > 0) ||
                (Array.isArray(group?.comment_questions) &&
                    group.comment_questions.length > 0)
            ));
    const isAssessmentsEmpty =
        !hasAssessmentContent && assessmentSubmittedList.length == 0;
    const questions =
        assessmentQuestionGroups && assessmentQuestionGroups.length > 0
            ? assessmentQuestionGroups
            : assessmentQuestionList;
    const showGoalSection = !hideGoalSection;
    const showRatingSummary = !hideRatingSummary;
    const ratingEnabledForQuestions =
        !hideQuestionRatings &&
        Number(selectedTimeframe.is_assessment_question_rating) === 1;
    // const renderReadOnly =
    //     selfAssessmentStatus === SELF_ASSESSMENT_STATUS.SUBMITTED;
    const renderReadOnly =
        selfAssessmentStatus === SELF_ASSESSMENT_STATUS.SUBMITTED ||
        isReadOnly;
    const hasGoalEntries = goalList.length > 0 || goalSubmittedList.length > 0;
    const showActionButtons =
        selectedTimeframe &&
        (hasAssessmentContent || hasGoalEntries || showEmptySelfStepActions);
    const shouldShowEmptyStepMessage =
        showEmptySelfStepActions && !hasAssessmentContent && !hasGoalEntries;

    return (
        <>
            {renderReadOnly ? (
                <>
                    <Flexbox className="self-assessment-container">
                        {hasSubmittedAssessmentContent && (
                            <>
                                {showRatingSummary && (
                                    <ContainerIntroBox
                                        iconType="self"
                                        text="Review your self assessment form"
                                        description={
                                            'Your submitted responses are displayed below for review'
                                        }
                                        rating={finalSubmittedAssessmentRating}
                                        ratingLabel={finalSubmittedAssessmentRatingLabel}
                                        ratingLabels={selectedTimeframe.rating_labels || []}
                                        resultData={combinedSubmittedFinalRating}
                                        finalAssessmentRatingLabel={
                                            combinedSubmittedFinalRatingLabel
                                        }
                                        isRatingEnabledQuestions={
                                            ratingEnabledForQuestions ? 1 : 0
                                        }
                                    />
                                )}
                                <ReadOnlyNotice />
                                <Card className="assessment-answer-container">
                                    {assessmentSubmittedGroups?.length > 0 ? (
                                        <AssessmentReadOnlyList
                                            data={assessmentSubmittedGroups}
                                            finalAssessmentRating={
                                                finalSubmittedAssessmentRating
                                            }
                                            weightage={selectedTimeframe.is_weight_allow}
                                            ratingLabels={
                                                selectedTimeframe.rating_labels || []
                                            }
                                            isRatingEnabledQuestions={
                                                ratingEnabledForQuestions ? 1 : 0
                                            }
                                            accountId={accountId}
                                            visibilityConfig={accountVisibilityConfig}
                                            isAnswerAllowedOnQuestion={
                                                selectedTimeframe?.is_answer_allow_on_question
                                            }
                                        />
                                    ) : (
                                        <AssessmentReadOnlyList
                                            data={assessmentSubmittedList}
                                            finalAssessmentRating={
                                                finalSubmittedAssessmentRating
                                            }
                                            weightage={selectedTimeframe.is_weight_allow}
                                            ratingLabels={
                                                selectedTimeframe.rating_labels || []
                                            }
                                            isRatingEnabledQuestions={
                                                ratingEnabledForQuestions ? 1 : 0
                                            }
                                            accountId={accountId}
                                            visibilityConfig={accountVisibilityConfig}
                                            isAnswerAllowedOnQuestion={
                                                selectedTimeframe?.is_answer_allow_on_question
                                            }
                                        />
                                    )}
                                </Card>
                            </>
                        )}
                        {showGoalSection && goalSubmittedList?.length > 0 && (
                            <>
                                <ContainerIntroBox
                                    iconType="self"
                                    text="Review your self goal Rating form"
                                    description={
                                        'Your submitted responses are displayed below for review'
                                    }
                                    rating={finalRating}
                                    ratingLabel={goalSubmittedRatingLabel}
                                    ratingLabels={selectedTimeframe.rating_labels || []}
                                    resultData={combinedSubmittedFinalRating}
                                    finalGoalRatingLabel={
                                        combinedSubmittedFinalRatingLabel
                                    }
                                    containerType="goal"
                                />
                                <Card className="assessment-answer-container">
                                    <GoalReadOnlyList
                                        data={goalSubmittedList}
                                        goalFinalRating={finalRating}
                                        weightage={selectedTimeframe.is_weight_allow}
                                        ratingLabels={
                                            selectedTimeframe.rating_labels || []
                                        }
                                        subGoalsByGoalId={subGoalsByGoalId}
                                        openSubGoals={openSubGoals}
                                        toggleSubGoals={toggleSubGoals}
                                    />
                                </Card>
                            </>
                        )}
                    </Flexbox>
                </>
            ) : (
                <Flexbox className="self-assessment-container">
                    <Flexbox flexDirection="column">
                        {hasAssessmentContent && (
                            <>
                                {showRatingSummary && (
                                    <ContainerIntroBox
                                        iconType="self"
                                        text="Complete your self assessment form"
                                        description={
                                            'Answer each question thoughtfully to provide a comprehensive self-assessment'
                                        }
                                        rating={finalAssessmentRating}
                                        ratingLabel={finalAssesCalcRatingLabel}
                                        ratingLabels={
                                            selectedTimeframe.rating_labels || []
                                        }
                                        resultData={combinedSelfFinalRating}
                                        finalAssessmentRatingLabel={
                                            combinedSelfFinalRatingLabel
                                        }
                                        isRatingEnabledQuestions={
                                            ratingEnabledForQuestions ? 1 : 0
                                        }
                                    />
                                )}

                                <Card className="assessment-question-container">
                                    <AssessmentQuestionList
                                        questions={questions}
                                        answers={answers}
                                        assessmentRatings={assessmentRatings}
                                        categoryWiseRatings={categoryWiseRatings}
                                        selectedTimeframe={selectedTimeframe}
                                        onChange={onChange}
                                        onCheckboxChange={onCheckboxChange}
                                        onFileUpload={onFileUpload}
                                        onRatingChange={onAssessmentRatingChange}
                                        weightage={selectedTimeframe.is_weight_allow}
                                        isRatingEnabledQuestions={
                                            ratingEnabledForQuestions ? 1 : 0
                                        }
                                        accountVisibilityConfig={
                                            accountVisibilityConfig
                                        }
                                        accountId={accountId}
                                        remarkAnswers={remarkAnswers}
                                        updateRemarkAnswer={updateRemarkAnswer}
                                    />
                                </Card>
                            </>
                        )}
                    </Flexbox>

                    <Flexbox flexDirection="column">
                        {showGoalSection && goalList && goalList.length > 0 && (
                            <>
                                <ContainerIntroBox
                                    iconType="self"
                                    text="Complete your Goal Ratings"
                                    description={
                                        'Answer each question thoughtfully to provide a comprehensive self-assessment'
                                    }
                                    rating={finalRating}
                                    ratingLabel={finalGoalCalcRatingLabel}
                                    ratingLabels={selectedTimeframe.rating_labels || []}
                                    resultData={combinedSelfFinalRating}
                                    finalGoalRatingLabel={combinedSelfFinalRatingLabel}
                                    containerType="goal"
                                />
                                <Card className="assessment-question-container">
                                    <GoalRatingForm
                                        goalList={goalList}
                                        goalRatings={goalRatings}
                                        onRatingChange={onRatingChange}
                                        weightage={selectedTimeframe.is_weight_allow}
                                        ratingLabels={
                                            selectedTimeframe.rating_labels || []
                                        }
                                        startRatingValue={selectedTimeframe.start_rating_value}
                                        endRatingValue={selectedTimeframe.end_rating_value}
                                        subGoalsByGoalId={subGoalsByGoalId}
                                        openSubGoals={openSubGoals}
                                        toggleSubGoals={toggleSubGoals}
                                    />
                                </Card>
                            </>
                        )}
                    </Flexbox>
                    {shouldShowEmptyStepMessage && (
                        <Card className="assessment-answer-container" style={{ padding: '18px 22px' }}>
                            <div style={{ color: '#172b4d', lineHeight: 1.7, fontSize: '15px' }}>
                                This step does not contain any assessment questions at the moment. You may still save it as a draft or publish it to complete the step when you are ready.
                            </div>
                        </Card>
                    )}

                    {selectedTimeframe && showActionButtons && (
                        <Flexbox flexDirection="row" gap="10px">
                            <OutlinedButton
                                text={'Save as Draft'}
                                onClick={() =>
                                    onSubmitForm(SELF_ASSESSMENT_STATUS.DRAFT)
                                }
                                style={{ marginRight: '10px' }}
                            />
                            <FilledButton
                                text={'Save as Published'}
                                onClick={() => setShowPublishConfirm(true)}
                            />
                        </Flexbox>
                    )}
                </Flexbox>
            )}
            {isGoalsEmpty && isAssessmentsEmpty && !showEmptySelfStepActions && (
                <Flexbox className="self-assessment-container">
                    <Card className="assessment-answer-container">
                        <EmptyStateNotice
                            title="Waiting for Assessments and Goals"
                            description="We’ll notify you as soon as they’re ready."
                        />
                    </Card>
                </Flexbox>
            )}
        </>
    );
};

export default SelfTabContent;
